import { connect } from 'react-redux';

import type { State } from 'state';
import {
	changeEmailInput,
	checkLoginAction,
	forgotPassword,
	createPassword,
	loginAttempt,
	resetLogin,
} from 'state/actions/login';
import { getBaseUrl } from 'state/selectors/env';
import { getLoginAnnouncementLocale } from 'state/selectors/login';
import withAnalyticsContext from '@atlaskit/analytics-next/withAnalyticsContext';
import withAnalyticsEvents from '@atlaskit/analytics-next/withAnalyticsEvents';
import { LoginForm } from './login-form';

export default connect(
	(state: State) => ({
		loginAnnouncementLocale: getLoginAnnouncementLocale(state),
		baseUrl: getBaseUrl(state),
	}),
	{
		changeEmailInputAction: changeEmailInput,
		checkLoginActionAction: checkLoginAction,
		forgotPasswordAction: forgotPassword,
		createPasswordAction: createPassword,
		loginAttemptAction: loginAttempt,
		resetLoginAction: resetLogin,
	},
)(withAnalyticsContext({ componentName: 'loginForm' })(withAnalyticsEvents()(LoginForm)));
